import { SERVER_API } from "../../Constant";
import axios from "axios";

// Vehicle Types
export const FetchVehicleTypes_api = async () => {
  try {
    const response = await axios.get(`${SERVER_API}/Vehicles/fetch_types.php`);
    return response.data;
  } catch (error) {
    console.error("Fetch vehicle types failed:", error);
    return { error: "Fetch vehicle types failed" };
  }
};

export const AddVehicleType_api = async (payload: any) => {
  try {
    const formData = new FormData();
    formData.append("inputs", JSON.stringify(payload));
    const response = await axios.post(
      `${SERVER_API}/Vehicles/add_type.php`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error("Add vehicle type failed:", error);
    return { error: "Add vehicle type failed" };
  }
};

export const UpdateVehicleType_api = async (payload: any) => {
  try {
    const formData = new FormData();
    formData.append("inputs", JSON.stringify(payload));
    const response = await axios.post(
      `${SERVER_API}/Vehicles/update_type.php`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error("Update vehicle type failed:", error);
    return { error: "Update vehicle type failed" };
  }
};

// Vehicle Models
export const FetchVehicleModals_api = async () => {
  try {
    const response = await axios.get(`${SERVER_API}/Vehicles/fetch_modals.php`);
    return response.data;
  } catch (error) {
    console.error("Fetch vehicle models failed:", error);
    return { error: "Fetch vehicle models failed" };
  }
};

export const AddVehicleModal_api = async (payload: any) => {
  try {
    const formData = new FormData();
    formData.append("inputs", JSON.stringify(payload));
    const response = await axios.post(
      `${SERVER_API}/Vehicles/add_modal.php`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error("Add vehicle model failed:", error);
    return { error: "Add vehicle model failed" };
  }
};

export const UpdateVehicleModal_api = async (payload: any) => {
  try {
    const formData = new FormData();
    formData.append("inputs", JSON.stringify(payload));
    const response = await axios.post(
      `${SERVER_API}/Vehicles/update_modal.php`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error("Update vehicle model failed:", error);
    return { error: "Update vehicle model failed" };
  }
};

// Vehicle Colors
export const FetchVehicleColors_api = async () => {
  try {
    const response = await axios.get(`${SERVER_API}/Vehicles/fetch_colors.php`);
    return response.data;
  } catch (error) {
    console.error("Fetch vehicle colors failed:", error);
    return { error: "Fetch vehicle colors failed" };
  }
};

export const AddVehicleColor_api = async (payload: any) => {
  try {
    const formData = new FormData();
    formData.append("inputs", JSON.stringify(payload));
    const response = await axios.post(
      `${SERVER_API}/Vehicles/add_color.php`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error("Add vehicle color failed:", error);
    return { error: "Add vehicle color failed" };
  }
};

export const UpdateVehicleColor_api = async (payload: any) => {
  try {
    const formData = new FormData();
    formData.append("inputs", JSON.stringify(payload));
    const response = await axios.post(
      `${SERVER_API}/Vehicles/update_color.php`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error("Update vehicle color failed:", error);
    return { error: "Update vehicle color failed" };
  }
};

// VTM Mappings
export const FetchVTMMappings_api = async () => {
  try {
    const response = await axios.get(
      `${SERVER_API}/Vehicles/fetch_vtm_mappings.php`,
    );
    return response.data;
  } catch (error) {
    console.error("Fetch VTM mappings failed:", error);
    return { error: "Fetch VTM mappings failed" };
  }
};

export const AddVTMMapping_api = async (payload: any) => {
  try {
    const formData = new FormData();
    formData.append("inputs", JSON.stringify(payload));
    const response = await axios.post(
      `${SERVER_API}/Vehicles/add_vtm_mapping.php`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error("Add VTM mapping failed:", error);
    return { error: "Add VTM mapping failed" };
  }
};

export const UpdateVTMMapping_api = async (payload: any) => {
  try {
    const formData = new FormData();
    formData.append("inputs", JSON.stringify(payload));
    const response = await axios.post(
      `${SERVER_API}/Vehicles/update_vtm_mapping.php`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error("Update VTM mapping failed:", error);
    return { error: "Update VTM mapping failed" };
  }
};

// Vehicles
export const FetchVehicles_api = async (
  page = 1,
  limit = 10,
  filters: any = {},
) => {
  try {
    const response = await axios.get(
      `${SERVER_API}/Vehicles/fetch_vehicles.php`,
      {
        params: { page, limit, ...filters },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Fetch vehicles failed:", error);
    return { error: "Fetch vehicles failed" };
  }
};

export const AddVehicle_api = async (payload: any) => {
  try {
    const formData = new FormData();
    formData.append("inputs", JSON.stringify(payload));
    const response = await axios.post(
      `${SERVER_API}/Vehicles/add_vehicle.php`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error("Add vehicle failed:", error);
    return { error: "Add vehicle failed" };
  }
};

export const UpdateVehicle_api = async (payload: any) => {
  try {
    const formData = new FormData();
    formData.append("inputs", JSON.stringify(payload));
    const response = await axios.post(
      `${SERVER_API}/Vehicles/update_vehicle.php`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error("Update vehicle failed:", error);
    return { error: "Update vehicle failed" };
  }
};

export const UpdateVehicleReturnStatus_api = async (payload: any) => {
  try {
    const formData = new FormData();
    formData.append("inputs", JSON.stringify(payload));
    const response = await axios.post(
      `${SERVER_API}/Vehicles/update_vehicle_return_status.php`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error("Update vehicle return status failed:", error);
    return { error: "Update vehicle return status failed" };
  }
};
